import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import AdminPanel from "./Components/AdminPanel/AdminPanel";

import AdminSuperAdminAuth from "./Components/AdminSuperAdminAuth/AdminSuperAdminAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// AppContent Component
const AppContent = () => {
  const loggedIn_status = useSelector((state) => state.auth.Status);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(loggedIn_status);
    
    if (loggedIn_status !== "Logged In") {
      navigate("/login");
    }
  }, []);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<AdminSuperAdminAuth />} />

        {loggedIn_status === "Logged In" && (
          <Route path="/*" element={<AdminPanel />} />
        )}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

// Main App Component
const App = () => (
  <div className="min-h-screen flex flex-col overflow-x-hidden bg-gray-200 ">
    <AppContent />
  </div>
);

export default App;
